import { useBreadcrumbTrail } from '@/data/Content/BreadcrumbTrail';
import { DATA_KEY_PRODUCT } from '@/data/constants/dataKey';
import { useEmarsys } from '@/data/context/emarsysCtx';
import { useEffect } from 'react';
import {
	getSearchTerm,
} from '@/data/utils/getProductListQueryParameters';
import { useNextRouter } from '@/data/Content/_NextRouter';

/**
 * Dispatches Emarsys tag data for the PLP based on breadcrumb + searchTerm.
 *
 * - Category page (breadcrumb has non-product entries) → EMARSYS_CATEGORY_TAG_DATA.
 * - Search results without a breadcrumb (only `searchTerm`) → EMARSYS_SEARCH_TAG_DATA.
 * - Empty breadcrumb AND no searchTerm → no-op (avoids the crash that the
 *   previous inline implementation had when accessing arrayCategories[-1]).
 */
export const usePlpEmarsysTracking = () => {
	const { dispatch } = useEmarsys();
	const { breadcrumb } = useBreadcrumbTrail();
	const router = useNextRouter();
	const query = router.query;
	const searchTerm = getSearchTerm(query);

	useEffect(() => {
		const arrayCategories = breadcrumb?.filter((e) => e.type !== DATA_KEY_PRODUCT) ?? [];

		if (arrayCategories.length === 0) {
			if (!searchTerm) return;
			dispatch({
				type: 'EMARSYS_SEARCH_TAG_DATA',
				payload: {
					searchTerm: ['searchTerm', searchTerm],
					tag: [
						'tag',
						'custom_search',
						{
							search_param: searchTerm,
							search_order: 'Relevancia',
							order_direction: 'asc',
						},
					],
				},
			});
			return;
		}

		const last = arrayCategories[arrayCategories.length - 1];
		const categories = arrayCategories.map((tag) => tag.label).join('>');
		dispatch({
			type: 'EMARSYS_CATEGORY_TAG_DATA',
			payload: {
				category: ['category', categories],
				tag: [
					'tag',
					'content_pageview',
					{
						content_title: window.document.title,
						content_url: window.document.location.href,
						content_category: last.label,
						content_tag: last.label,
					},
				],
			},
		});
	}, [dispatch, breadcrumb, searchTerm]);
};
